export const GENERATE_SHIPMENT_NUMBER = "GENERATE_SHIPMENT_NUMBER";

export const onGenerateShipmentNumber = (payload) => {
  return {
    type: GENERATE_SHIPMENT_NUMBER,
    payload,
  };
};
